/* Off-Road collection template — sort dropdown + mobile nav.
   The palette is now server-rendered from theme settings, so the old
   floating colour widget from the mockup is gone. */
(function () {
  'use strict';

  /* ---- Sort dropdown (options are real ?sort_by= links) ---- */
  document.querySelectorAll('[data-sort-dd]').forEach(function (dd) {
    var trigger = dd.querySelector('.sort-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      var open = dd.classList.toggle('open');
      trigger.setAttribute('aria-expanded', open);
    });

    document.addEventListener('click', function (e) {
      if (!dd.contains(e.target)) {
        dd.classList.remove('open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        dd.classList.remove('open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ---- Sidebar accordion (exclusive — opening one closes the rest) ---- */
  var sidebar = document.getElementById('offroadSidebar');

  if (sidebar) {
    sidebar.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-accordion-toggle]');
      if (!toggle) return;

      e.preventDefault();

      var li = toggle.closest('li');
      var wasOpen = li.classList.contains('open');

      Array.prototype.forEach.call(li.parentElement.children, function (sibling) {
        sibling.classList.remove('open');
      });

      if (!wasOpen) li.classList.add('open');

      /* A parent toggle is href="#" — nothing navigates, so the server-rendered
         "active" state (which follows the real page URL) never moves here on its
         own. Move the highlight to the clicked toggle client-side, same as the
         approved design's own script does for any non-submenu click. Real links
         (the "All Off-Road" row, flat items, submenu items) navigate for real and
         get their active state from the next full page load — untouched here. */
      var current = sidebar.querySelector('a.active');
      if (current) current.classList.remove('active');
      toggle.classList.add('active');
    });
  }

  /* ---- Sidebar highlight, corrected against the real URL ----
     The server highlights based on collection.filters[].values[].active, which
     only lists filter values that exist among the collection's current products.
     If a tag matches zero products anywhere in the collection, Shopify's filter
     engine doesn't register it as "applied" at all — indistinguishable, server
     side, from no filter being selected. Liquid also has no way to read the raw
     query string to work around that. The browser can, though: compare the
     page's own filter params against each sidebar link's own params and correct
     the highlight to match, regardless of whether any product actually matched.
     Safe to run even when the server already got it right — becomes a no-op. */
  if (sidebar) {
    var FILTER_PARAM_KEYS = ['filter.p.tag'];
    var hereParams = new URLSearchParams(window.location.search);
    var activeFilters = {};

    FILTER_PARAM_KEYS.forEach(function (k) {
      if (hereParams.has(k)) activeFilters[k] = hereParams.get(k).toLowerCase();
    });

    if (Object.keys(activeFilters).length) {
      var matched = null;

      sidebar.querySelectorAll('a[href]').forEach(function (a) {
        if (matched) return;

        var url;
        try {
          url = new URL(a.getAttribute('href'), window.location.origin);
        } catch (e) {
          return;
        }

        var carriesAnyFilterKey = FILTER_PARAM_KEYS.some(function (k) {
          return url.searchParams.has(k);
        });
        if (!carriesAnyFilterKey) return;

        var allMatch = Object.keys(activeFilters).every(function (k) {
          var linkValue = url.searchParams.get(k);
          return linkValue !== null && linkValue.toLowerCase() === activeFilters[k];
        });

        if (allMatch) matched = a;
      });

      if (matched) {
        var currentlyActive = sidebar.querySelector('a.active');
        if (currentlyActive && currentlyActive !== matched) {
          currentlyActive.classList.remove('active');
        }
        matched.classList.add('active');

        var parentSubmenu = matched.closest('.submenu');
        if (parentSubmenu) {
          var parentLi = parentSubmenu.closest('li');
          if (parentLi) {
            Array.prototype.forEach.call(parentLi.parentElement.children, function (sibling) {
              sibling.classList.remove('open');
            });
            parentLi.classList.add('open');
          }
        }
      }
    }
  }

  /* ---- Preview shim ----
     Two params keep this page on the right theme+template while the theme is
     still unpublished:
       view             - selects collection.off-road.liquid. Needed until the
                          collection's template is assigned in admin, which can
                          only happen once this theme is published (the admin
                          dropdown reads templates from the LIVE theme).
       preview_theme_id - selects the unpublished theme itself.
     Clicking THIS collection's own sidebar filter, sort option or page link
     would drop both and fall back to the live theme's default collection
     template. Liquid can't read query params, so re-attach them client side.
     Inert once the theme is published and the template assigned.

     SCOPE — this deliberately reverses an earlier rule, so the history matters.

     It used to carry the params only to links pointing back at the CURRENT
     collection. That was correct when exactly one collection was off-road:
     ?view=X is not tied to a specific collection, so carrying it onto every
     /collections/ link made Vehicle and Universal render off-road too, which
     at the time was a bug (confirmed against radiumauto.com).

     That is now the intended behaviour. The customer asked for one continuous
     off-road experience across the collections and content pages, so off-road
     mode is sticky site-wide and the restriction is replaced by an explicit
     deny-list of the places it must NOT follow. If off-road is ever narrowed
     back to a single collection, restore the same-collection check rather than
     trimming this list. */
  var here = new URLSearchParams(window.location.search);
  var carry = ['view', 'preview_theme_id'].filter(function (k) {
    return here.has(k);
  });

  /* Paths that must stay in the normal design.

       /checkout, /account - Shopify-hosted, not themeable by us.

       /policies           - store policy pages. "policy" is not a valid
                             Shopify template type (checked against the docs),
                             so these can never take an alternate template and
                             ?view= would be a no-op. NOTE the footer menu's
                             "Terms of Service" points here, while the header
                             menu's points at /pages/radium-engineering-terms-
                             of-service, which does work in Off-Road. Those are
                             two different documents; repointing the footer
                             menu is an admin change, not a code one.

       /a                  - app proxy paths, incl. /a/blog (Technical
                             Articles, a Magefan app). App-proxy responses have
                             no template suffix, so ?view= does nothing.

     Find a Dealer (/pages/store-locator) is NOT excluded. It was, on the
     reasoning that its Storeify locator is an app block and app blocks only
     render inside JSON templates. That was wrong. Measured against the live
     site: /pages/contact-us uses page.contact.json, which carries no storeify
     block, yet loads the locator scripts exactly like the pages that do —
     while collections and products load none. The scripts come from the app
     EMBED, which is scoped by page TYPE, not by template file. An Off-Road
     page is still a page-type request, so the embed injects there too. */
  var OFFROAD_DENY = ['/checkout', '/account', '/policies', '/a'];

  /* Links that point at a DIFFERENT document in the Off-Road design.

     The footer menu's "Terms of Service" targets /policies/terms-of-service, a
     Shopify-hosted policy page. "policy" is not a valid theme template type
     (confirmed against Shopify's own template docs), so that URL can never
     render in this design — it is in the deny-list above for that reason, and
     a shopper clicking it was being dropped back into the Automotive layout.

     The store already publishes the same material as a real page, and the
     HEADER menu points there. So in the Off-Road design the footer follows the
     header. Two things worth being clear about:

       - these are genuinely different documents ("Terms of service" vs "Radium
         Engineering Terms of Service"), so this substitutes content, it does
         not merely re-route a URL. Doing it was an explicit decision, not an
         assumption.
       - it only applies inside the Off-Road design. The normal site's footer
         still goes to the policy page.

     The cleaner fix is repointing the footer menu in Shopify admin, which
     fixes both designs and makes the two menus agree. Once that is done this
     map can be emptied — it will simply stop matching. */
  var OFFROAD_LINK_MAP = {
    '/policies/terms-of-service': '/pages/radium-engineering-terms-of-service'
  };

  /* layout/off-road.liquid adds entries here for policies that have an
     equivalent normal page — currently the shipping policy. It is emitted from
     Liquid rather than hard-coded alongside the terms entry above because the
     page has to be checked for existence first: mapping a link to a page that
     hasn't been created yet would turn a working policy link into a 404, which
     is worse than the wrong design. No page, no entry, no change in behaviour. */
  if (window.OFFROAD_LINK_MAP_EXTRA) {
    for (var orMapKey in window.OFFROAD_LINK_MAP_EXTRA) {
      if (Object.prototype.hasOwnProperty.call(window.OFFROAD_LINK_MAP_EXTRA, orMapKey)) {
        OFFROAD_LINK_MAP[orMapKey] = window.OFFROAD_LINK_MAP_EXTRA[orMapKey];
      }
    }
  }

  /* Exact segment match only. A bare prefix test would also catch unrelated
     paths that merely start with the same letters (/accounts-payable). */
  function offroadDenied(pathname) {
    for (var i = 0; i < OFFROAD_DENY.length; i++) {
      var p = OFFROAD_DENY[i];
      if (pathname === p || pathname.indexOf(p + '/') === 0) return true;
    }
    return false;
  }

  /* The Off-Road home, read from the header logo rather than hardcoded.
     sections/off-road-header.liquid renders it as
     <a href="{{ offroad_home_url }}" class="logo-wrap">, where offroad_home_url
     is the off-road collection plus ?view=off-road. Reading it back means this
     stays correct if that Liquid ever changes — no duplicated handle to drift. */
  function offroadHomeUrl() {
    var logo = document.querySelector('a.logo-wrap[href]');
    if (!logo) return null;
    try {
      return new URL(logo.getAttribute('href'), window.location.origin);
    } catch (e) {
      return null;
    }
  }

  /* Rewrite one link so it stays in the Off-Road design. Safe to call repeatedly
     — it is a no-op once the params are present. */
  function offroadifyLink(a) {
    var raw = a.getAttribute('href');
    /* Anchors and non-navigating hrefs: nothing to carry. */
    if (!raw || raw.charAt(0) === '#') return;

    var url;
    try {
      url = new URL(raw, window.location.origin);
    } catch (e) {
      return;
    }
    /* Also filters mailto:/tel:, whose origin is "null". */
    if (url.origin !== window.location.origin) return;

    /* Applied BEFORE the deny check, so a mapped path is judged on where it
       ends up rather than where it started. */
    if (OFFROAD_LINK_MAP[url.pathname]) url.pathname = OFFROAD_LINK_MAP[url.pathname];

    /* "Shop now" in an empty cart goes to the Off-Road home, not a generic
       product list. The two empty states ship different targets — the cart page
       uses routes.collections_url (/collections) and the drawer uses
       routes.all_products_collection_url (/collections/all) — and neither is
       this design's home. /collections is the worse of the two: there is no
       off-road template for the collections-list page, so it would drop the
       shopper back into the normal design entirely.

       Matched by container rather than by URL so only these two buttons are
       affected; other links to those paths are left alone.

       Mind the containers — they differ between the two, and the obvious guess
       is wrong for the cart page:

         cart page  .cart__warnings  >  .cart__empty-wrapper (text only)
                                     >  <a>                  <- SIBLING of it
         drawer     .drawer__inner-empty > .cart__empty-wrapper (text only)
                                         > <a>

       So .cart__empty-wrapper never contains the button in either case. Using it
       matched nothing on the cart page and the link fell through unchanged. */
    if (a.closest && a.closest('.cart__warnings, .drawer__inner-empty')) {
      var home = offroadHomeUrl();
      if (home) {
        url.pathname = home.pathname;
        url.search = home.search;
      }
    }

    if (offroadDenied(url.pathname)) return;

    var changed = false;
    carry.forEach(function (k) {
      if (!url.searchParams.has(k)) {
        url.searchParams.set(k, here.get(k));
        changed = true;
      }
    });
    if (changed || url.pathname !== new URL(raw, window.location.origin).pathname) {
      a.setAttribute('href', url.pathname + url.search + url.hash);
    }
  }

  /* Catch links that did not exist when the page loaded.
     The sweep below runs once, over the server-rendered markup. But several
     links are created later by JavaScript — most visibly the "Shop now" button
     in the empty cart, built by cart.js from window.cartStrings after the last
     item is removed, on both the mini-cart and the cart page. Those never went
     through the sweep, so they pointed at the plain URL and dropped the shopper
     back onto the normal site.
     Handled on click, in the capture phase, so it applies to any link whenever
     it appeared and there is no observer running for the life of the page. */
  if (carry.length) {
    document.addEventListener(
      'click',
      function (e) {
        var a = e.target && e.target.closest && e.target.closest('a[href]');
        if (a) offroadifyLink(a);
      },
      true
    );
  }

  /* Sweep the server-rendered markup once at load, so links are already correct
     on hover and for middle-click / "open in new tab", which never fire the
     click handler above. */
  if (carry.length) {
    document.querySelectorAll('a[href]').forEach(offroadifyLink);
  }

  /* ---- Side navigation drawer (phones) ---- */
  var menuBtn = document.getElementById('menuBtn');
  var sideDrawer = document.getElementById('sideDrawer');
  var drawerOverlay = document.getElementById('drawerOverlay');
  var drawerClose = document.getElementById('drawerClose');

  if (menuBtn && sideDrawer && drawerOverlay) {
    var setDrawer = function (open) {
      sideDrawer.classList.toggle('open', open);
      drawerOverlay.classList.toggle('open', open);
      document.body.classList.toggle('drawer-open', open);
      menuBtn.setAttribute('aria-expanded', open);
      sideDrawer.setAttribute('aria-hidden', !open);
    };

    menuBtn.addEventListener('click', function () { setDrawer(true); });
    drawerOverlay.addEventListener('click', function () { setDrawer(false); });
    if (drawerClose) drawerClose.addEventListener('click', function () { setDrawer(false); });

    sideDrawer.querySelectorAll('.drawer-nav a').forEach(function (a) {
      a.addEventListener('click', function () { setDrawer(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });
  }

  /* ---- Mobile cart icon opens the same slide-in drawer ----
     cart-drawer.js (layout/off-road.liquid) only wires up the first
     #cart-icon-bubble it finds via querySelector — that's the desktop
     top-bar icon. The mobile top bar has its own separate cart icon
     (id="orMobileCartIcon", off-road-header.liquid) since HTML can't have
     two elements sharing the same id; this opens the same <cart-drawer>
     custom element instance directly instead of duplicating cart-drawer.js's
     own open/close logic. cart-drawer.js loads before this file (both
     deferred, same document order = same execution order), so the
     <cart-drawer> element is already upgraded with its open() method by
     the time this runs. */
  var orMobileCartIcon = document.getElementById('orMobileCartIcon');
  var orCartDrawerEl = document.querySelector('cart-drawer');

  if (orMobileCartIcon && orCartDrawerEl) {
    orMobileCartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      orCartDrawerEl.open(orMobileCartIcon);
    });
  }

  /* ---- Sidebar "Search By Products" (off-road-grid.liquid) ----
     Filters only the .product-card elements this grid itself renders, so
     it can only ever narrow down products already in this off-road
     collection — there's nothing else in this container to match against.
     Matches on the visible product name text, not the whole card's link
     text, so price/badge text can't produce false matches. */
  var sidebarSearchInput = document.getElementById('orSidebarSearchInput');
  var sidebarSearchCount = document.getElementById('orSidebarSearchCount');
  var orProductGrid = document.getElementById('orProductGrid');
  var orSearchEmpty = document.getElementById('orSearchEmpty');
  var orPagination = document.getElementById('orPagination');
  var orResultCount = document.getElementById('orResultCount');
  var orSortDd = document.getElementById('orSortDd');

  if (sidebarSearchInput && orProductGrid) {
    var productCards = orProductGrid.querySelectorAll('.product-card');

    var updateSidebarSearchCount = function (visible) {
      if (!sidebarSearchCount) return;
      sidebarSearchCount.textContent = 'Showing ' + visible + ' product' + (visible !== 1 ? 's' : '');
    };

    updateSidebarSearchCount(productCards.length);

    // Server-rendered "Showing 1-19 of 19 products", kept so it can be put
    // back verbatim when the search box is cleared.
    var orResultCountOriginal = orResultCount ? orResultCount.textContent : '';

    sidebarSearchInput.addEventListener('input', function () {
      var filter = sidebarSearchInput.value.trim().toUpperCase();
      var visible = 0;

      productCards.forEach(function (card) {
        var nameEl = card.querySelector('.product-name');
        var name = nameEl ? (nameEl.textContent || '').toUpperCase() : '';
        var matches = filter === '' || name.indexOf(filter) > -1;
        card.style.display = matches ? '' : 'none';
        if (matches) visible++;
      });

      // The page-number pagination, the "Showing 1-12 of 22 products"
      // toolbar count, and the sort dropdown are all server-rendered for
      // the unfiltered page — this search can only ever narrow what's
      // already on the page, it can't know in advance whether zero
      // matches is possible. Without this, all three stayed visible and
      // unchanged, contradicting the "No matches" message right next to
      // them — sorting in particular has nothing to act on when there's
      // nothing left to sort.
      //
      // Pagination is hidden for *any* active search, not just a search
      // that matches nothing: those page buttons count the unfiltered
      // collection, so a search narrowing 19 cards down to 3 still showed
      // "1 2 3" underneath them, and clicking a page reloads from the
      // server and silently drops the filter. The count is rewritten
      // rather than hidden so the toolbar doesn't go empty mid-search.
      var searching = filter !== '';

      if (orSearchEmpty) orSearchEmpty.style.display = visible === 0 ? '' : 'none';
      if (orPagination) orPagination.style.display = searching ? 'none' : '';
      if (orSortDd) orSortDd.style.display = visible === 0 ? 'none' : '';
      if (orResultCount) {
        orResultCount.style.display = visible === 0 ? 'none' : '';
        orResultCount.textContent = searching
          ? 'Showing ' + visible + ' matching product' + (visible !== 1 ? 's' : '')
          : orResultCountOriginal;
      }

      updateSidebarSearchCount(visible);
    });
  }

  /* ---- Reset scroll-lock state on back-forward-cache restore ----
     Both the mobile drawer above and the image zoom modal
     (off-road-pdp.liquid) set document.body.style.overflow = 'hidden'
     while open. If a page is left with either open, then the user
     navigates away and hits Back, some browsers restore the page from
     bfcache exactly as it was frozen — including that inline style and
     open classes — without re-running any of this file's normal open/close
     logic. The page looks fully loaded but the body can never scroll
     again, which reads as "the scrollbar is just gone." pageshow with
     event.persisted true is the standard signal for a bfcache restore. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.body.style.overflow = '';
    document.body.classList.remove('drawer-open');
    document.getElementById('sideDrawer')?.classList.remove('open');
    document.getElementById('drawerOverlay')?.classList.remove('open');
    document.getElementById('orImgModal')?.classList.remove('open');
  });

  /* Stop the cart drawer from overwriting this header's cart icon.

     CartDrawer.renderContents() (cart-drawer.js) refreshes a list of sections
     after every AJAX add, and that list includes 'cart-icon-bubble' with no
     selector, so it does:
         document.getElementById('cart-icon-bubble').innerHTML = <main theme markup>

     On the main site that id belongs to the theme's own cart-icon-bubble
     section, so replacing its contents is exactly right. This header hand-rolls
     its cart icon and only borrows the id so cart-drawer.js will wire up the
     click. The result was the off-road icon being replaced with main-theme
     markup that off-road.css doesn't style — a stray count bubble and a missing
     cart glyph.

     It only surfaces when something calls renderContents, i.e. the stock
     product-form.js path used by products WITHOUT the bcpo options
     configurator. Products that have one go through productoption.js and the
     mini-cart popup, which never calls it. That's why it looked dev-only: the
     dev store has no configurator products, while the live catalogue is mostly
     configurator products.

     Dropping that one entry leaves the drawer itself refreshing normally and
     leaves this header alone. Lives in this file, which only loads on the
     off-road layout, so the main site's cart icon keeps refreshing as before. */
  /* Keep the slide-in drawer's "View cart" link pointing at the Off-Road cart.

     layout/off-road.liquid renders the drawer snippet with `offroad: true`, so
     the link is correct on first paint. But the drawer's contents get replaced
     by fetching `?section_id=cart-drawer`, and that goes through
     sections/cart-drawer.liquid — a bare `{%- render 'cart-drawer' -%}` with no
     flag, because a standalone section render has no way of knowing which
     design the shopper is in. The refresh happens after every add to cart,
     i.e. exactly when someone is about to open the drawer, so in practice the
     link almost always came back without the suffix.

     Rewriting it here covers every re-render, whatever triggered it. Matches
     only the cart page itself — `/cart` with or without a query — so
     /cart/add, /cart/change and the drawer's own form action are left alone. */
  function orFixDrawerCartLinks(root) {
    var scope = root || document.querySelector('cart-drawer');
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.indexOf('view=off-road') !== -1) return;
      var parts = href.split('?');
      var path = parts[0].replace(/\/+$/, '');
      if (!/\/cart$/.test(path)) return;
      var query = parts[1] ? parts[1] + '&view=off-road' : 'view=off-road';
      a.setAttribute('href', path + '?' + query);
    });
  }

  var orDrawerEl = document.querySelector('cart-drawer');
  if (orDrawerEl) {
    orFixDrawerCartLinks(orDrawerEl);
    new MutationObserver(function () {
      orFixDrawerCartLinks(orDrawerEl);
    }).observe(orDrawerEl, { childList: true, subtree: true });
  }

  /* Stop a null focus target from failing the whole cart update.
   *
   * Found with the debugger, after several wrong guesses:
   *
   *   TypeError: Cannot read properties of null (reading 'focus')
   *     at trapFocus (global.js)   elementToFocus: null
   *     at cart.js
   *
   * global.js declares `function trapFocus(container, elementToFocus = container)`.
   * A default parameter only applies when the argument is UNDEFINED, never when
   * it is null — and cart.js passes the result of a querySelector straight in:
   *
   *   } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
   *     trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
   *
   * When `.cart-item` matches but `.cart-item__name` does not, that is null, the
   * default is skipped, and trapFocus throws. The throw lands in updateQuantity's
   * .catch, which shows "There was an error while updating your cart" — after the
   * removal has already succeeded on the server (the request returns 200). It also
   * aborts the rest of the update, so the drawer is left half-redrawn.
   *
   * Restoring the default trapFocus already documents makes this harmless: focus
   * the container when there is no specific element. Patched here rather than in
   * global.js because that file is shared with the main site, and this is Dawn's
   * own bug rather than something the Off-Road design introduced. */
  if (typeof window.trapFocus === 'function' && !window.trapFocus.__orNullSafe) {
    var orOriginalTrapFocus = window.trapFocus;
    window.trapFocus = function (container, elementToFocus) {
      if (!container) return;
      return orOriginalTrapFocus(container, elementToFocus || container);
    };
    window.trapFocus.__orNullSafe = true;
  }

  function orDropCartIconSection(klass) {
    if (typeof klass === 'undefined' || !klass || !klass.prototype) return;
    if (!klass.prototype.getSectionsToRender) return;
    /* hasOwnProperty, not a plain truthiness test. CartDrawerItems extends
       CartItems, so once CartItems.prototype is flagged the flag is visible on
       CartDrawerItems.prototype through the prototype chain — a plain check
       would skip the subclass, which is the one that actually needed patching. */
    if (Object.prototype.hasOwnProperty.call(klass.prototype, '__orIconPatched')) return;
    klass.prototype.__orIconPatched = true;
    var original = klass.prototype.getSectionsToRender;
    klass.prototype.getSectionsToRender = function () {
      return original.call(this).filter(function (section) {
        return section.id !== 'cart-icon-bubble';
      });
    };
  }

  /* CartDrawer covers the add-to-cart path. CartItems covers the cart PAGE:
     changing a quantity or removing a line there re-renders the same section
     list, so without this the off-road cart page would break its own header
     icon the moment a shopper edited a quantity.

     CartDrawerItems is the one that was missing, and it mattered more than the
     other two. It does not inherit CartItems' section list — it declares its
     OWN getSectionsToRender() (cart-drawer.js), so patching CartItems never
     reached it. Removing a line in the side cart therefore still asked for the
     cart-icon-bubble section, and cart.js's getSectionInnerHTML does

         .parseFromString(html, 'text/html').querySelector(selector).innerHTML

     with no null guard. A section that isn't in the response throws a
     TypeError there, the surrounding .catch in updateQuantity swallows it, and
     the shopper sees "There was an error while updating your cart" — even
     though the removal had already succeeded on the server. It also aborted
     the rest of the re-render, which is why the drawer could be left showing
     its old empty-cart state alongside a line item. */
  if (typeof CartDrawer !== 'undefined') orDropCartIconSection(CartDrawer);
  if (typeof CartItems !== 'undefined') orDropCartIconSection(CartItems);
  if (typeof CartDrawerItems !== 'undefined') orDropCartIconSection(CartDrawerItems);

  /* ...and keep the number itself correct, since the section that used to do
     that is no longer being rendered. updateHeaderBadges only writes
     textContent, so it updates the count without touching the markup. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (window.MiniCartPopup) window.MiniCartPopup.updateHeaderBadges(cart.item_count);
        })
        .catch(function () { /* leave the count as-is */ });
    });
  }

  /* ---- Find a Dealer: keep the map bubble clear of the sticky header ----

     Selecting a store opened its detail bubble with the top cut off. It is not
     clipped — it is covered. Measured on the live page with the bubble scrolled
     near the top of the window: the bubble ran from y=60 to y=300, the sticky
     header from y=0 to y=215 at z-index 200, so 155px of a 240px bubble sat
     behind the header. The bubble's own content is not scrolled or truncated
     (scrollHeight 182 == clientHeight 182), it simply isn't visible.

     Google Maps pans an info window into the MAP's viewport. It has no idea a
     sticky header is floating over the page, so it considers the job done, and
     there is no setting on the app to tell it otherwise. Nudging the page down
     afterwards is the part we control.

     A click listener rather than a MutationObserver: the observer would have to
     watch the map subtree, which mutates constantly as tiles load, to catch one
     element appearing. One capture-phase listener on the locator covers both
     ways a bubble opens — clicking a store in the list, and clicking a marker
     on the map, since the map canvas is inside this container too.

     Checked twice because the pan is animated and its duration isn't ours to
     know; the second pass is a no-op once the first has cleared the header. */
  var orLocator = document.getElementById('storeifyapps-storelocator-shortcode');

  if (orLocator) {
    var orStickyHeader = document.getElementById('shopify-section-off-road-header');

    var orRevealMapBubble = function () {
      var bubble = document.querySelector('.gm-style-iw-c');
      if (!bubble || !orStickyHeader) return;

      var box = bubble.getBoundingClientRect();
      if (!box.height) return;

      var hidden = orStickyHeader.getBoundingClientRect().bottom - box.top;
      /* A few pixels of overlap aren't worth moving the page for, and without a
         threshold the second pass could fight the first over a rounding error. */
      if (hidden < 4) return;

      var reduceMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollBy({
        top: -(hidden + 12),
        left: 0,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    };

    orLocator.addEventListener('click', function () {
      setTimeout(orRevealMapBubble, 500);
      setTimeout(orRevealMapBubble, 1100);
    }, true);
  }
})();
